import { inject } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';

import { of } from 'rxjs';

import { coerceBooleanProperty } from '@ui/legacy-lib';
import { UserStore } from '@ui/tenant-pool/shared/user/data-access';

export const ExtendSearchGuard = (route: ActivatedRouteSnapshot) => {
  const { token, searching } = route.queryParams;
  const isSearching = coerceBooleanProperty(searching);

  inject(UserStore).setSearchingStatus({ token, isSearching });

  return of(false);
};
